import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const ArrowRight = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.93215 3.3608C9.12741 3.16554 9.44399 3.16554 9.63925 3.3608L13.925 7.64652C14.0187 7.74028 14.0714 7.86746 14.0714 8.00007C14.0714 8.13268 14.0187 8.25985 13.925 8.35362L9.63925 12.6393C9.44399 12.8346 9.12741 12.8346 8.93215 12.6393C8.73689 12.4441 8.73689 12.1275 8.93215 11.9322L12.3643 8.50007H2.42856C2.15242 8.50007 1.92856 8.27621 1.92856 8.00007C1.92856 7.72393 2.15242 7.50007 2.42856 7.50007H12.3643L8.93215 4.06791C8.73689 3.87265 8.73689 3.55606 8.93215 3.3608Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default ArrowRight
